module.exports = __webpack_public_path__ + "img/project-9.a62c1816.png";